class VideoManager {
  constructor(settings, modal, location) {
    this.modal = modal
    this.body = modal.querySelector('.modal-body')
    this.location = location

    this.sectionId = settings.sectionId
    this.delay = settings.delay
    this.type = settings.type
    this.src = settings.src
    this.id = settings.id
    this.autoplay = settings.autoplay
    this.muted = settings.muted
    this.loop = settings.loop
    this.controls = settings.controls

    this.params = {
      autoplay: this.getBin(this.autoplay),
      mute: this.getBin(this.muted),
      loop: this.getBin(this.loop),
    }

    this.videoId = `modal-video--${this.type}__${this.sectionId}`
    this.scriptId = `modal-script--${this.type}__${this.sectionId}`
    this.domElement = null
    this.player = null
    this.script = null
    this.sdk = this.type === 'vimeo'
      ? 'https://player.vimeo.com/api/player.js'
      : 'https://www.youtube.com/iframe_api'

    this.interval = null
    this.playerReady = false
  }

  getBin(bool) {
    return bool === 'false' ? 0 : 1
  }

  buildScript() {
    this.script = document.createElement('script')
    this.script.src = this.sdk
    this.script.id = this.scriptId
    this.location.parentNode.insertBefore(this.script, this.location)
  }

  embedSetup() {
    const iframeContainer = document.createElement('div')
    iframeContainer.id = this.videoId

    this.domElement = iframeContainer
    this.body.appendChild(iframeContainer)
  }

  videoSetup() {
    const video = document.createElement('video')
    const source = document.createElement('source')
    video.appendChild(source)

    this.autoplay === 'true' && video.setAttribute('autoplay', '')
    this.muted === 'true' && video.setAttribute('muted', '')
    if ( this.muted === 'true' ) video.muted = true
    this.loop === 'true' && video.setAttribute('loop', '')
    this.controls === 'true' && video.setAttribute('controls', '')

    source.setAttribute('src', this.src)
    source.setAttribute('type', 'video/mp4')

    this.player = video
    this.domElement = video
    this.body.appendChild(this.domElement)
  }

  startObserver() {
    if ( this.interval ) return

    this.interval = setInterval(() => {
      if ( window.Vimeo || window.YT ) this.playerReady = true

      if ( this.playerReady ) {
        clearInterval(this.interval)
        this.createEmbed()
        this.interval = null
      }
    }, 100)
  }

  createEmbed() {
    const { autoplay, mute, loop } = this.params
    
    if ( this.type === 'vimeo' ) {
      this.player = new Vimeo.Player(this.videoId, {
        id: this.id,
        height: '1200',
        width: '2000',
        autoplay: this.autoplay,
        muted: this.muted,
        loop: this.loop
      })
    } else {
      this.player = new YT.Player(this.videoId, {
        height: '100',
        width: '100',
        videoId: this.id,
        playerVars: {
          autoplay,
          mute,
          loop
        }
      })
    }
  }

  create() {
    if ( this.type === 'vimeo' || this.type === 'youtube' ) {
      this.buildScript()
      this.embedSetup()

      if ( window.Vimeo || window.YT ) this.playerReady = true

      if ( this.playerReady ) {
        this.createEmbed()
      } else {
        this.startObserver()
      }
    } else {
      this.videoSetup()
    }
  }

  start() {
    setTimeout(() => {
      if ( this.type === 'html5' ) {
        this.player.play()
      }
    }, this.delay)
  }

  stop() {
    if ( this.type === 'youtube' ) this.player.stopVideo()
    else this.player.pause()
  }

  destroy() {
    if ( this.interval ) {
      clearInterval(this.interval)
      this.interval = null
    }

    if ( this.domElement ) {
      this.domElement.remove()
      this.domElement = null
      document.getElementById(this.videoId).remove()
    }

    if ( this.type === 'vimeo' || this.type === 'youtube' ) this.player.destroy()

    if ( this.script ) {
      this.script.remove()
      this.script = null
      document.getElementById(this.scriptId).remove()
    }
  }
}

const VideoModal = () => {
  const modals = Array.from(document.querySelectorAll('.video-modal__container'))
  
  if ( modals.length < 1 ) return

  const location = document.getElementsByTagName('script')[0]

  modals.forEach(modal => {
    document.body.appendChild(modal)
    const data = modal.dataset
    const settings = {
      sectionId: data.sectionId,
      delay: data.videoDelay,
      type: data.videoType,
      src: data?.videoSource || null,
      id: data?.videoId || null,
      autoplay: data.videoAutoplay,
      muted: data.videoMuted,
      loop: data.videoLoop,
      controls: data?.videoControls || null
    }

    const manager = new VideoManager(settings, modal, location)
    
    modal.addEventListener('show.bs.modal', () => manager.create())
    modal.addEventListener('shown.bs.modal', () => manager.start())
    modal.addEventListener('hide.bs.modal', () => manager.stop())
    modal.addEventListener('hidden.bs.modal', () => manager.destroy())
  })
}

export default VideoModal